export default "__VITE_ASSET__37998cbb__"